// extracted by mini-css-extract-plugin
export var attachmentContainer = "_rl-0";
export var fileList = "_rl-2";
export var removeFileButton = "_rl-1";